module.exports = __webpack_public_path__ + "img/card-logo.116486cf.png";